import { FileBase } from '../FileBase';

export class Radius extends FileBase {
  location = null;
  radius = null;

  isValid() {
    return (this.location && this.radius) || (super.isValid() && this.radius);
  }

  isEqualTo(other) {
    return (
      super.isEqualTo(other) && this.location === other.location && this.radius === other.radius
    );
  }
}
